import { media, mixins, styled, typography } from '@pulse-web-ui/theme';

export const ContentWrapper = styled.div`
  ${mixins.flex({ horizontal: false, gap: 16 })}
  margin-bottom: 32px;
`;

export const PromoWrapper = styled.div`
  ${mixins.flex({ gap: 8 })};
  width: 100%;
`;

export const PromoTextInput = styled.div`
  flex: auto;
`;

export const PromoSubmitButton = styled.div`
  ${typography.bold18};
  width: 100%;
  ${media.desktop} {
    width: auto;
  }
  div div {
    transition: 300ms ease all;
  }
`;
